import { useEffect, useRef, useState } from "react";

const useLazyLoading = (
  items,
  lazyLoadItemLoadCount,
  lazyLoadPixelThreshold
) => {
  const [visibleItemsCount, setVisibleItemsCount] = useState(
    window.innerHeight / 60
  );
  const [lazyLoadItemCount, setLazyLoadItemCount] = useState(0);
  const itemContainerRef = useRef(null);
  useEffect(() => {
    // Update window size when the window is resized
    const handleResize = () => {
      setLazyLoadItemCount(window.innerHeight / 60);
      setVisibleItemsCount((prev) => Math.max(prev, window.innerHeight / 60));
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleScroll = () => {
    const container = itemContainerRef.current;
    if (
      container.scrollHeight - container.scrollTop <=
      container.clientHeight + lazyLoadPixelThreshold
    ) {
      setVisibleItemsCount((prev) =>
        Math.min(prev + lazyLoadItemLoadCount, items.length)
      );
    }
  };

  useEffect(() => {
    setVisibleItemsCount(
      Math.max(
        Math.min(lazyLoadItemLoadCount, items.length),
        window.innerHeight / 60
      )
    );

    const container = itemContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [items, itemContainerRef.current]);

  const loadedItems = items.slice(0, visibleItemsCount);
  return { loadedItems, itemContainerRef };
};
export default useLazyLoading;
